<template>
  <v-container fluid>
    <v-btn icon @click="$router.back()">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="display-1 pl-3" id="title">分析項目（ホルダマスタ）管理</span>

    <v-row align="center" justify="center" dense>
      <v-col cols="12" xl="12" dense>
        <v-card v-if= "!isSystemAdmin" flat outlined class="ma-5 pa-3">
          <div class="subtitle-2 mb-2">
            <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
            <span class="primary--text">メンテナンス機能について</span>
          </div>
          <p class="caption">
              この機能はシステム管理者のみ利用できる機能です。<br>
          </p>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="10">
        <div class="px-3">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            placeholder="検索"
            filled
          ></v-text-field>
        </div>
      </v-col>
      <v-col cols="2">
        <div class="px-3">
          <v-checkbox
            v-model="showActiveOnly"
            label="管理対象のみ"
            dense
          ></v-checkbox>
        </div>
      </v-col>

      <v-col cols="8" xl="8" dense>
        総件数：{{filteredItems.length}}件
      </v-col>
      <v-col cols="4" xl="4" dense class="text-right">
      </v-col>

      <v-col cols="12" xl="12" dense>
        <v-data-table
          ref="dataTable"
          :headers="headers"
          :items="filteredItems"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          :sort-by="['Value']"
          :loading="loading"
          loading-text="読込中"
          no-data-text="データがありません。"          
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="(data) => { HolderMordal(data) }"
          height="450"
          :fixed-header=true
        >
          <template v-slot:[`item.at1001`]="{ item }">
            <img v-if="item.at1001 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1001 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1001 }}</span>
          </template>
          <template v-slot:[`item.at1002`]="{ item }">
            <img v-if="item.at1002 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1002 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1002 }}</span>
          </template>
          <template v-slot:[`item.at1003`]="{ item }">
            <img v-if="item.at1003 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1003 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1003 }}</span>
          </template>
          <template v-slot:[`item.at1004`]="{ item }">
            <img v-if="item.at1004 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1004 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1004 }}</span>
          </template>
          <template v-slot:[`item.at1005`]="{ item }">
            <img v-if="item.at1005 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1005 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1005 }}</span>
          </template>
          <template v-slot:[`item.at1101`]="{ item }">
            <img v-if="item.at1101 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1101 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1101 }}</span>
          </template>
          <template v-slot:[`item.at1102`]="{ item }">
            <img v-if="item.at1102 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1102 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1102 }}</span>
          </template>
          <template v-slot:[`item.at1103`]="{ item }">
            <img v-if="item.at1103 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1103 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1103 }}</span>
          </template>
          <template v-slot:[`item.at1104`]="{ item }">
            <img v-if="item.at1104 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1104 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1104 }}</span>
          </template>
          <template v-slot:[`item.at1105`]="{ item }">
            <img v-if="item.at1105 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at1105 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at1105 }}</span>
          </template>
          <template v-slot:[`item.at2001`]="{ item }">
            <img v-if="item.at2001 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at2001 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at2001 }}</span>
          </template>
          <template v-slot:[`item.at3001`]="{ item }">
            <img v-if="item.at3001 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3001 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3001 }}</span>
          </template>
          <template v-slot:[`item.at3002`]="{ item }">
            <img v-if="item.at3002 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3002 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3002 }}</span>
          </template>
          <template v-slot:[`item.at3003`]="{ item }">
            <img v-if="item.at3003 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3003 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3003 }}</span>
          </template>
          <template v-slot:[`item.at3101`]="{ item }">
            <img v-if="item.at3101 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3101 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3101 }}</span>
          </template>
          <template v-slot:[`item.at3102`]="{ item }">
            <img v-if="item.at3102 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3102 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3102 }}</span>
          </template>
          <template v-slot:[`item.at3103`]="{ item }">
            <img v-if="item.at3103 === '1'" src="/img/icons/check.png" width="16" height="16" />
            <img v-else-if="item.at3103 === '0'" src="/img/icons/incorrect.png" width="16" height="16" />
            <span v-else>{{ item.at3103 }}</span>
          </template>
          <template v-slot:[`item.Price`]="{ item }">
            <div class="text-right">{{ item.Price ? Number(item.Price).toLocaleString() : '' }}</div>
          </template>
          <template v-slot:[`item.Require`]="{ item }">
            <div class="text-right">{{ item.Require ? Number(item.Require).toLocaleString() : '' }}</div>
          </template>
          <template v-slot:[`item.isActive`]="{ item }">
            <v-chip 
              small 
              :color="item.isActive === '1' ? 'green' : 'grey'" 
              class="white--text" 
              @click.stop="isSuperUser ? toggleIsActive(item) : null"
              :style="isSuperUser ? 'cursor: pointer;' : 'cursor: default;'"
            >
              {{ item.isActive === '1' ? '✔' : '✕' }}
            </v-chip>
          </template>
        </v-data-table>
      </v-col>  
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col cols="10" lg="10" md='10' sm='10' xs="10">
        <v-pagination
         v-model="page"
         :total-visible="totalVisible"
         :length="pageCount"
         color="amber darken-1 black--text"
        light 
        circle>
        </v-pagination>
      </v-col>
      <v-col cols="4" lg="2"  md='4' sm='4' xs="6">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-select>
      </v-col>
    </v-row>

    <v-row v-if= "isSystemAdmin" align="center" justify="center" dense>
      <v-col v-if="isDeveloper" cols="12" xl="12" dense class="text-right">
        <v-btn 
          v-if="isSystemAdmin" 
          color="blue" 
          @click="initializeHolderMaster"
          class="ma-2"
        >
          ホルダマスタ初期化
        </v-btn>
      </v-col>
    </v-row>


    <v-dialog v-model="isHolderMordal" max-width="90%">
      <v-card>
        <v-card-title primary-title class="headline grey lighten-2">
          <span class="ml-2 caption">分析項目（ホルダ）詳細:</span>
        </v-card-title>
        <v-card-text>
        <v-chip small label outlined class="mt-3 mb-3">ホルダ情報</v-chip>
        <v-chip v-if="dialogData.isActive === '0'" small color="red" class="white--text ml-3">管理対象外</v-chip>          
        <v-row dense>
          <v-col cols="2">
            <span class="ml-2 caption">分析区分コード</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ dialogData.Value }}</span>
          </v-col>
          <v-col cols="6">
            <span class="ml-2 caption">分析区分名称</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ dialogData.Text }}</span>
          </v-col>
          <v-col cols="2">
            <span class="ml-2 caption">登録日</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ dialogData.createdAt ? new Date(dialogData.createdAt).toLocaleString('ja-JP', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).replace(/\//g, '/') : '' }}</span>
          </v-col>
          <v-col cols="2">
            <span class="ml-2 caption">更新日</span>
            <span class=".d-flex .d-sm-none"><br></span>
            <span class="ml-3 body-1">{{ dialogData.updatedAt ? new Date(dialogData.updatedAt).toLocaleString('ja-JP', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).replace(/\//g, '/') : '' }}</span>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-chip small label outlined class="mt-3 mb-3">Web依頼許可状況</v-chip>          
        <v-row dense style="border: 1px solid #e0e0e0;">
          <v-col cols="2" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption"></span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">潤滑油</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">燃料</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">グリス</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">冷却水</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <span class="ml-2 body-1">水グリコール</span>
          </v-col>
        </v-row>

        <v-row dense style="border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
          <v-col cols="2" class="d-flex align-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">一般：社定法</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1001"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1002"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1003"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1004"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <v-switch
              v-model="switchAt1005"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
        </v-row>

        <v-row dense style="border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
          <v-col cols="2" class="d-flex align-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">一般：公定法</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1101"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1102"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1103"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt1104"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <v-switch
              v-model="switchAt1105"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
        </v-row>

        <v-row dense style="border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
          <v-col cols="2" class="d-flex align-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">JET：社定法</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt2001"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption">ー</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption">ー</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption">ー</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <span class="ml-2 caption">ー</span>
          </v-col>
        </v-row>

        <v-row dense style="border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
          <v-col cols="2" class="d-flex align-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">JXTG：社定法</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3001"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3002"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3003"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption">ー</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <span class="ml-2 caption">ー</span>
          </v-col>
        </v-row>

        <v-row dense style="border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
          <v-col cols="2" class="d-flex align-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 body-1">JXTG：公定法</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3101"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3102"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <v-switch
              v-model="switchAt3103"
              :disabled="!isSuperUser"
              hide-details
            >
            </v-switch>
          </v-col>
          <v-col cols="2" class="d-flex justify-center" style="border-right: 1px solid #e0e0e0;">
            <span class="ml-2 caption">ー</span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center">
            <span class="ml-2 caption">ー</span>
          </v-col>
        </v-row>

      </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="amber darken-3" rounded @click="updateData" :disabled="!isSuperUser" class="ma-4">変更</v-btn>
          <v-btn rounded @click="isHolderMordal=false" class="ma-4">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 変更確認用のダイアログ -->
    <v-dialog v-model="isChangeConfirmDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline">変更確認</v-card-title>
        <v-card-text>
          <div v-if="changesList.length > 0">
            <p>以下の項目を変更します。よろしいですか？</p>
            <div v-for="change in changesList" :key="change" class="mb-2">
              <div v-if="change.includes('→')">
                <div class="body-2 mb-1 font-weight-bold">{{ change.split(':')[0] }}:</div>
                <div class="ml-4">
                  <v-chip 
                    small 
                    :color="change.includes('依頼できない →') ? 'grey' : 'green'" 
                    :text-color="'white'"
                    class="mr-2"
                  >
                    {{ change.includes('依頼できない →') ? '依頼できない' : '依頼できる' }}
                  </v-chip>
                  <span class="mx-2">→</span>
                  <v-chip 
                    small 
                    :color="change.includes('→ 依頼できる') ? 'green' : 'grey'" 
                    :text-color="'white'"
                  >
                    {{ change.includes('→ 依頼できる') ? '依頼できる' : '依頼できない' }}
                  </v-chip>
                </div>
              </div>
              <div v-else class="body-2">
                {{ change }}
              </div>
            </div>
          </div>
          <div v-else>
            変更はありませんでした。
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="amber darken-1" @click="confirmUpdate">OK</v-btn>
          <v-btn rounded @click="isChangeConfirmDialog = false">キャンセル</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { listHolders, sortedAnalizeItemByType } from '../graphql/queries'
import { updateHolder, createAnalizeItem, updateAnalizeItem } from '../graphql/mutations'

export default {

  name: "listHolders",
  mixins:[],
  head: {
    title: { inner: '分析項目（ホルダ）一覧'},
  },
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      itemsPerPageList: [ 50,100, ],
      totalVisible: 7,
      search: '',
      showActiveOnly: true,
      loading: false, 
      isHolderMordal: false,
      isChangeConfirmDialog: false,
      selectedItemIndex: -1,
      originalData: {},
      changesList: [],
      data: {
          AnalizeItemNames:[],
      },
      dialogData: {
        at1001: '0',
        at1002: '0',
        at1003: '0',
        at1004: '0',
        at1005: '0',
        at1101: '0',
        at1102: '0',
        at1103: '0',
        at1104: '0',
        at1105: '0',
        at2001: '0',
        at3001: '0',
        at3002: '0',
        at3003: '0',
        at3101: '0',
        at3102: '0',
        at3103: '0'
      },

      items: [],
      headers: [
        {
          text: 'コード',
          align: 'start',
          value: 'Value',
          class: "grey darken-2 white--text",
          width: "5%",
        },
        {
          text: '分析項目名',
          align: 'start',
          value: 'Text',
          class: "grey darken-2 white--text",
          width: "15%",
        },
        {
          text: '分析料金',
          align: 'start',
          value: 'Price',
          class: "grey darken-2 white--text",
          width: "6%",
        },
        {
          text: 'サンプル量（mL）',
          align: 'start',
          value: 'Require',
          class: "grey darken-2 white--text",
          width: "6%",
          sortable: false 
        },
        {
          text: '社_潤滑油',
          align: 'start',
          value: 'at1001',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '社_燃料',
          align: 'start',
          value: 'at1002',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '社_グリス',
          align: 'start',
          value: 'at1003',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '社_冷却水',
          align: 'start',
          value: 'at1004',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '社_水グリ',
          align: 'start',
          value: 'at1005',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '公_潤滑油',
          align: 'start',
          value: 'at1101',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '公_燃料',
          align: 'start',
          value: 'at1102',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '公_グリス',
          align: 'start',
          value: 'at1103',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '公_冷却水',
          align: 'start',
          value: 'at1104',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '公_水グリ',
          align: 'start',
          value: 'at1105',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JET_潤滑油',
          align: 'start',
          value: 'at2001',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX社_潤滑油',
          align: 'start',
          value: 'at3001',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX社_燃料',
          align: 'start',
          value: 'at3002',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX社_グリス',
          align: 'start',
          value: 'at3003',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX公_潤滑油',
          align: 'start',
          value: 'at3101',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX公_燃料',
          align: 'start',
          value: 'at3102',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: 'JX公_グリス',
          align: 'start',
          value: 'at3103',
          class: "grey darken-2 white--text",
          width: "4%",
          sortable: false 
        },
        {
          text: '管理',
          align: 'start',
          value: 'isActive',
          class: "grey darken-2 white--text",
          width: "2%",
          sortable: false 
        },
      ]
    }
  },
  filters: {
  },
  computed: {
    isSuperUser () {
      return this.$store.state.isSuperUser
    },
    isDeveloper () {
      return this.$store.state.isDeveloper
    },
    isSystemAdmin : function() {
      return this.$store.state.isSystemAdmin
    },
    switchAt1001: {
      get() {
        return this.dialogData.at1001 === '1'
      },
      set(value) {
        this.dialogData.at1001 = value ? '1' : '0'
      }
    },
    switchAt1002: {
      get() { return this.dialogData.at1002 === '1' },
      set(value) { this.dialogData.at1002 = value ? '1' : '0' }
    },
    switchAt1003: {
      get() { return this.dialogData.at1003 === '1' },
      set(value) { this.dialogData.at1003 = value ? '1' : '0' }
    },
    switchAt1004: {
      get() { return this.dialogData.at1004 === '1' },
      set(value) { this.dialogData.at1004 = value ? '1' : '0' }
    },
    switchAt1005: {
      get() { return this.dialogData.at1005 === '1' },
      set(value) { this.dialogData.at1005 = value ? '1' : '0' }
    },
    switchAt1101: {
      get() { return this.dialogData.at1101 === '1' },
      set(value) { this.dialogData.at1101 = value ? '1' : '0' }
    },
    switchAt1102: {
      get() { return this.dialogData.at1102 === '1' },
      set(value) { this.dialogData.at1102 = value ? '1' : '0' }
    },
    switchAt1103: {
      get() { return this.dialogData.at1103 === '1' },
      set(value) { this.dialogData.at1103 = value ? '1' : '0' }
    },
    switchAt1104: {
      get() { return this.dialogData.at1104 === '1' },
      set(value) { this.dialogData.at1104 = value ? '1' : '0' }
    },
    switchAt1105: {
      get() { return this.dialogData.at1105 === '1' },
      set(value) { this.dialogData.at1105 = value ? '1' : '0' }
    },
    switchAt2001: {
      get() { return this.dialogData.at2001 === '1' },
      set(value) { this.dialogData.at2001 = value ? '1' : '0' }
    },
    switchAt3001: {
      get() { return this.dialogData.at3001 === '1' },
      set(value) { this.dialogData.at3001 = value ? '1' : '0' }
    },
    switchAt3002: {
      get() { return this.dialogData.at3002 === '1' },
      set(value) { this.dialogData.at3002 = value ? '1' : '0' }
    },
    switchAt3003: {
      get() { return this.dialogData.at3003 === '1' },
      set(value) { this.dialogData.at3003 = value ? '1' : '0' }
    },
    switchAt3101: {
      get() { return this.dialogData.at3101 === '1' },
      set(value) { this.dialogData.at3101 = value ? '1' : '0' }
    },
    switchAt3102: {
      get() { return this.dialogData.at3102 === '1' },
      set(value) { this.dialogData.at3102 = value ? '1' : '0' }
    },
    switchAt3103: {
      get() { return this.dialogData.at3103 === '1' },
      set(value) { this.dialogData.at3103 = value ? '1' : '0' }
    },
    filteredItems() {
      if (this.showActiveOnly) {
        return this.items.filter(item => item.isActive === '1')
      }
      return this.items
    }
  },
  mounted: async function () {
    this.initialize()
  },
  watch: {
    page() {
      this.$nextTick(() => {
        const tableWrapper = this.$refs.dataTable.$el.querySelector('.v-data-table__wrapper')
        if (tableWrapper) {
          tableWrapper.scrollTop = 0
        }
      })
    }
  },
  methods: {
    initialize: async function() {
      let items = await API.graphql(graphqlOperation(listHolders, {limit: 999}))
      this.items = items.data.listHolders.items
      console.log('items', items)
    },
    HolderMordal: async function(data) {
      this.selectedItemIndex = this.items.findIndex(item => item.Value === data.Value)
      // 元のデータを保存
      this.originalData = {
        ...data,
        at1001: data.at1001,
        at1002: data.at1002,
        at1003: data.at1003,
        at1004: data.at1004,
        at1005: data.at1005,
        at1101: data.at1101,
        at1102: data.at1102,
        at1103: data.at1103,
        at1104: data.at1104,
        at1105: data.at1105,
        at2001: data.at2001,
        at3001: data.at3001,
        at3002: data.at3002,
        at3003: data.at3003,
        at3101: data.at3101,
        at3102: data.at3102,
        at3103: data.at3103
      }
      // 編集用データを作成
      this.dialogData = {
        ...data,
        at1001: data.at1001,
        at1002: data.at1002,
        at1003: data.at1003,
        at1004: data.at1004,
        at1005: data.at1005,
        at1101: data.at1101,
        at1102: data.at1102,
        at1103: data.at1103,
        at1104: data.at1104,
        at1105: data.at1105,
        at2001: data.at2001,
        at3001: data.at3001,
        at3002: data.at3002,
        at3003: data.at3003,
        at3101: data.at3101,
        at3102: data.at3102,
        at3103: data.at3103
      }
      this.isHolderMordal = true  
    },
    updateData: function() {
      if (this.selectedItemIndex >= 0) {
        // 変更内容をチェック
        const changes = []
        const fieldNames = {
          at1001: '一般：社定法_潤滑油',
          at1002: '一般：社定法_燃料',
          at1003: '一般：社定法_グリス',
          at1004: '一般：社定法_冷却水',
          at1005: '一般：社定法_水グリコール',
          at1101: '一般：公定法_潤滑油',
          at1102: '一般：公定法_燃料',
          at1103: '一般：公定法_グリス',
          at1104: '一般：公定法_冷却水',
          at1105: '一般：公定法_水グリコール',
          at2001: 'JET：社定法_潤滑油',
          at3001: 'JXTG_社定法_潤滑油',
          at3002: 'JXTG_社定法_燃料',
          at3003: 'JXTG_社定法_グリス',
          at3101: 'JXTG_社定法_潤滑油',
          at3102: 'JXTG_社定法_燃料',
          at3103: 'JXTG_社定法_グリス'
        }
        
        Object.keys(fieldNames).forEach(field => {
          if (this.originalData[field] !== this.dialogData[field]) {
            const oldValue = this.originalData[field] === '1' ? '依頼できる' : '依頼できない'
            const newValue = this.dialogData[field] === '1' ? '依頼できる' : '依頼できない'
            changes.push(`${fieldNames[field]}: \n    ${oldValue} → ${newValue}`)
          }
        })
        
        this.changesList = changes
        this.isChangeConfirmDialog = true
      }
    },
    initializeHolderMaster: async function() {
      if (!confirm('ホルダマスタを初期化します。\n\n注意：この操作により、全てのホルダの分析区分が一旦リセットされ、AnalizeItemテーブルのisActive="1"の項目に基づいて再設定されます。\n\nよろしいですか？')) {
        return
      }

      try {
        // 1. 全Holderのat1001等をすべて"0"に更新
        const updatePromises = this.items.map(async (holder) => {
          const updateInput = {
            id: holder.id,
            at1001: "0",
            at1002: "0",
            at1003: "0",
            at1004: "0",
            at1005: "0",
            at1101: "0",
            at1102: "0",
            at1103: "0",
            at1104: "0",
            at1105: "0",
            at2001: "0",
            at3001: "0",
            at3002: "0",
            at3003: "0",
            at3101: "0",
            at3102: "0",
            at3103: "0",
            isActive: "1"
          }
          await API.graphql(graphqlOperation(updateHolder, { input: updateInput }))
        })
        
        await Promise.all(updatePromises)
        console.log('全Holderの分析区分を"0"に初期化完了')

        // 2. AnalizeItemテーブルからisActive="1"の項目を検索し、対応するHolderを更新
        const analizeTypeToField = {
          '1001': 'at1001',
          '1002': 'at1002',
          '1003': 'at1003',
          '1004': 'at1004',
          '1005': 'at1005',
          '1101': 'at1101',
          '1102': 'at1102',
          '1103': 'at1103',
          '1104': 'at1104',
          '1105': 'at1105',
          '2001': 'at2001',
          '3001': 'at3001',
          '3002': 'at3002',
          '3003': 'at3003',
          '3101': 'at3101',
          '3102': 'at3102',
          '3103': 'at3103'
        }

        // 各分析区分ごとにAnalizeItemを検索
        for (const [analizeType, fieldName] of Object.entries(analizeTypeToField)) {
          try {
            const { listAnalizeItems } = await import('../graphql/queries')
            const analizeItems = await API.graphql(graphqlOperation(listAnalizeItems, {
              filter: {
                AnalizeType: { eq: analizeType },
                or: [
                  { isActive: { eq: "1" } },
                  { isActive: { attributeExists: false } }
                ]
              },
              limit: 999
            }))

            // 該当するAnalizeItemのValueでHolderを検索し、対応するフィールドを"1"に更新
            for (const analizeItem of analizeItems.data.listAnalizeItems.items) {
              const holderToUpdate = this.items.find(holder => holder.Value === analizeItem.Value)
              if (holderToUpdate) {
                const updateInput = {
                  id: holderToUpdate.id,
                  [fieldName]: "1"
                }
                await API.graphql(graphqlOperation(updateHolder, { input: updateInput }))
                console.log(`Updated Holder ${holderToUpdate.Value} ${fieldName} to "1"`)
              }
            }
          } catch (error) {
            console.log(`Error processing AnalizeType ${analizeType}:`, error)
          }
        }

        // 3. 画面を再読み込み
        await this.initialize()
        alert('ホルダマスタの初期化が完了しました。')
      } catch (error) {
        console.log('ホルダマスタ初期化エラー:', error)
        alert('ホルダマスタの初期化中にエラーが発生しました。')
      }
    },
    confirmUpdate: async function() {
      console.log('Updated data:', this.dialogData)

      let holder = {}
      try {
        holder["id"] = this.items[this.selectedItemIndex].id
        holder["at1001"] = this.dialogData["at1001"]
        holder["at1002"] = this.dialogData["at1002"]
        holder["at1003"] = this.dialogData["at1003"]
        holder["at1004"] = this.dialogData["at1004"]
        holder["at1005"] = this.dialogData["at1005"]
        holder["at1101"] = this.dialogData["at1101"]
        holder["at1102"] = this.dialogData["at1102"]
        holder["at1103"] = this.dialogData["at1103"]
        holder["at1104"] = this.dialogData["at1104"]
        holder["at1105"] = this.dialogData["at1105"]
        holder["at2001"] = this.dialogData["at2001"]
        holder["at3001"] = this.dialogData["at3001"]
        holder["at3002"] = this.dialogData["at3002"]
        holder["at3003"] = this.dialogData["at3003"]
        holder["at3101"] = this.dialogData["at3101"]
        holder["at3102"] = this.dialogData["at3102"]
        holder["at3103"] = this.dialogData["at3103"]

        console.log("holder update", holder);
        await API.graphql(graphqlOperation(updateHolder, {input: holder}))
        
        // 新しく「ON」になった分析項目をAnalizeItemテーブルに追加
        const analizeTypeMap = {
          at1001: '1001',
          at1002: '1002', 
          at1003: '1003',
          at1004: '1004',
          at1005: '1005',
          at1101: '1101',
          at1102: '1102',
          at1103: '1103',
          at1104: '1104',
          at1105: '1105',
          at2001: '2001',
          at3001: '3001',
          at3002: '3002',
          at3003: '3003',
          at3101: '3101',
          at3102: '3102',
          at3103: '3103'
        }
        
        for (const [field, analizeType] of Object.entries(analizeTypeMap)) {
          if (this.originalData[field] === '0' && this.dialogData[field] === '1') {
            // 新しくONになった項目
            try {
              const existingItems = await API.graphql(graphqlOperation(sortedAnalizeItemByType, {
                AnalizeType: analizeType,
                Value: { eq: this.dialogData.Value },
                limit: 1
              }))
              
              if (existingItems.data.sortedAnalizeItemByType.items.length === 0) {
                // レコードが存在しない場合は新規作成
                const newAnalizeItem = {
                  AnalizeType: analizeType,
                  Value: this.dialogData.Value,
                  Text: this.dialogData.Text,
                  Price: this.dialogData.Price || 0,
                  Require: this.dialogData.Require || 0,
                  isActive: '1'
                }
                await API.graphql(graphqlOperation(createAnalizeItem, {input: newAnalizeItem}))
                console.log(`Created AnalizeItem: ${analizeType}#${this.dialogData.Value}`)
              } else {
                // レコードが存在する場合はisActiveを1に更新
                const existingItem = existingItems.data.sortedAnalizeItemByType.items[0]
                const updateItem = {
                  id: existingItem.id,
                  isActive: '1'
                }
                await API.graphql(graphqlOperation(updateAnalizeItem, {input: updateItem}))
                console.log(`Updated AnalizeItem isActive: ${analizeType}#${this.dialogData.Value}`)
              }
            } catch (analizeItemErr) {
              console.log(`AnalizeItem error for ${field}:`, JSON.stringify(analizeItemErr))
            }
          } else if (this.originalData[field] === '1' && this.dialogData[field] === '0') {
            // ONからOFFに変更された項目
            try {
              const existingItems = await API.graphql(graphqlOperation(sortedAnalizeItemByType, {
                AnalizeType: analizeType,
                Value: { eq: this.dialogData.Value },
                limit: 1
              }))
              
              if (existingItems.data.sortedAnalizeItemByType.items.length === 0) {
                // レコードが存在しない場合はログ出力
                console.log(`AnalizeItem not found for deactivation: ${analizeType}#${this.dialogData.Value}`)
              } else {
                // レコードが存在する場合はisActiveを'0'に更新
                const existingItem = existingItems.data.sortedAnalizeItemByType.items[0]
                const updateItem = {
                  id: existingItem.id,
                  isActive: '0'
                }
                await API.graphql(graphqlOperation(updateAnalizeItem, {input: updateItem}))
                console.log(`Deactivated AnalizeItem: ${analizeType}#${this.dialogData.Value}`)
              }
            } catch (analizeItemErr) {
              console.log(`AnalizeItem deactivation error for ${field}:`, JSON.stringify(analizeItemErr))
            }
          }
        }
        
      } catch (err) {
        console.log("update holder error", JSON.stringify(err));
        console.log("update holder param", holder);
      }

      if (this.selectedItemIndex >= 0) {
        Object.assign(this.items[this.selectedItemIndex], this.dialogData)
      }
      this.isChangeConfirmDialog = false
      this.isHolderMordal = false
    },
    toggleIsActive: async function(item) {
      try {
        const newIsActive = item.isActive === '1' ? '0' : '1'
        
        await API.graphql(graphqlOperation(updateHolder, {
          input: {
            id: item.id,
            isActive: newIsActive
          }
        }))
        
        // ローカルデータを更新
        item.isActive = newIsActive
        
        console.log(`Holder ${item.Value} isActive updated to ${newIsActive}`)
      } catch (error) {
        console.error('Error updating isActive:', error)
      }
    },
  }
};
</script>
